<template>
    <div class="game">
        <hoger-lager ref="hogerLager"></hoger-lager>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { TimelineMax } from '@/vendor';
    import HogerLager from '@/app/components/HogerLager';

    export default {
        components: {
            'hoger-lager': HogerLager
        },

        created()
        {
            this.$store.dispatch( 'resetGame' );
        },

        methods: {
            getAnimateIn()
            {
                return this.$refs.hogerLager.getAnimateIn;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                tl.to( this.$el, 0.3, { opacity: 0 });

                return tl;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/pages/Game.vue